import { useEffect } from 'react';
import { create } from 'zustand';
import { supabase } from './supabase';
import type { Session } from '@supabase/supabase-js';

interface SessionState {
  session: Session | null;
  loading: boolean;
  setSession: (s: Session | null) => void;
  signOut: () => Promise<void>;
}

export const useSession = create<SessionState>((set) => ({
  session: null,
  loading: true,
  setSession: (session) => set({ session, loading: false }),
  signOut: async () => {
    await supabase.auth.signOut();
    set({ session: null });
  },
}));

/**
 * Bootstraps session state once per mount. Call in <App /> only.
 */
export const useSessionBootstrap = (): void => {
  const setSession = useSession((s) => s.setSession);
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session ?? null));
    const { data: sub } = supabase.auth.onAuthStateChange((_event, sess) => {
      setSession(sess ?? null);
    });
    return () => sub.subscription.unsubscribe();
  }, [setSession]);
};
